import { getAuth0AccessToken } from '../../auth/auth0Client';
import { API_BASE_URL } from '../config';
import { AppError, parseErrorResponse } from '../errors';

export interface GitHubOAuthExchangeParams {
  code: string;
}

export interface GitHubOAuthExchangeResponse {
  access_token: string;
  token_type: string;
  scope: string;
}

export interface GitHubOAuthExchangeErrorResponse {
  error: string;
  error_description?: string;
  error_uri?: string;
}

export async function githubOAuthExchange(
  params: GitHubOAuthExchangeParams
): Promise<GitHubOAuthExchangeResponse> {
  const auth0Token = await getAuth0AccessToken();
  if (!auth0Token) {
    throw new Error('Auth0 authentication required');
  }

  const response = await fetch(`${API_BASE_URL}/rpc/github_oauth_exchange`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth0Token}`,
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const errorPayload = await parseErrorResponse(response);
    if (errorPayload) {
      throw new AppError(errorPayload, response.status);
    }
    throw new Error(`GitHub OAuth exchange failed with status ${response.status}`);
  }

  return response.json() as Promise<GitHubOAuthExchangeResponse>;
}
